// extracted by mini-css-extract-plugin
export default {"textarea":"AutoresizeTextarea_textarea__XNhEj"};